import React from 'react'

import data from '../../../../data/dams'
import { DamsIcon } from '../../../../icons'

import LayerContent from '../../LayerContent'

import Description from './Description'
import Project from '../../Project'

const Dams = () => {
  return (
    <LayerContent>
      {({ active, setActiveProject }) =>
        data.entries.map(resource => (
          <Project
            data={resource}
            setActiveProject={setActiveProject}
            active={active}
            key={resource.id}
            name="dams"
            icon={() => <DamsIcon />}
          />
        ))
      }
    </LayerContent>
  )
}

export { Description as DamDescription }

export default Dams
